import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import InputWithTtile from '../../../../../../../Common/CustomInput/InputWithTtile';
import CustomButtonSS from '../../../../../../../Common/CustomButton/CustomButtonSS';
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import './ImsReceiptSearch.css';
import { getUserSelector } from '../../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { useSelector } from 'react-redux';

const ImsReceiptSearch = (props) => {
    const dispatch = useDispatch();
    const userPermission = useSelector(getUserSelector);
    const { selectedWarehouse, navigationBarList } = userPermission;
    const [poNumber, setPoNumber] = useState('');
    const [controlNumber, setControlNumber] = useState('');
    const isFSPay = props.appType === "FSPAY" ? true : false;
    const { warehouseList = [], selectedWarehouse: selectedWh, setSelectedWarehouse } = props;

    // Check if user has "Receipt Retrieval Filter" permission
    const hasReceiptRetrievalFilter = () => {
        if (!navigationBarList || navigationBarList.length === 0) return false;
        
        // Find the Reports feature in navigationBarList
        const reportsFeature = navigationBarList.find(feature => feature.PageName === "Reports");
        if (!reportsFeature || !reportsFeature.featureRole) return false;
        
        // Check if "Receipt Retrieval Filter" exists in featureRole array with Permission
        return reportsFeature.featureRole.some(
            role => role.ElementAccess === "Receipt Retrieval Filter" && role.Permission
        );
    };

    const showWarehouseSelection = hasReceiptRetrievalFilter();

    // Initialize selectedWh to "All" on mount if it's not set and warehouses are available
    useEffect(() => {
        if (isFSPay && !selectedWh && warehouseList.length > 0) {
            setSelectedWarehouse({ relaysiteId: 'all', warehouseName: 'All' });
        }
    }, [isFSPay, warehouseList.length]);


    const handleSearch = () => {
        // Determine warehouse ID based on selection
        let warehouseId;
        
        if (isFSPay) {
            // If "All" is selected or selectedWh is not set, pass all warehouse IDs separated by comma
            if (!selectedWh || (selectedWh && selectedWh.relaysiteId === 'all')) {
                // Filter out any invalid entries and get only actual warehouse IDs
                warehouseId = warehouseList
                    .filter(wh => wh.relaysiteId && wh.relaysiteId !== 'all')
                    .map(wh => wh.relaysiteId)
                    .join(',');
            } else {
                // Pass the selected warehouse ID
                warehouseId = selectedWh.relaysiteId;
            }
        } else {
            // For non-FSPAY, use the default warehouse
            warehouseId = selectedWarehouse.ID;
        }

        // Only dispatch if we have valid search criteria
        if ((poNumber || controlNumber) && warehouseId) {
            const payload = {
                PoNumber: poNumber,
                ControlNumber: controlNumber,
                IDDock: null,
                IDWarehouse: warehouseId,
                sendEmail: false,
                appType: props.appType
            };
            dispatch({ type: sagaActions.GET_TRUCK_REPORT_AND_RECEIPT_DETAILS, payload });
        }
    };

    const handleReset = () => {
        setPoNumber('');
        setControlNumber('');
        // Reset to "All" option for warehouse selection
        if (isFSPay && warehouseList.length > 0) {
            setSelectedWarehouse({ relaysiteId: 'all', warehouseName: 'All' });
        } else {
            setSelectedWarehouse(null);
        }
    };

    return (
        <div className="ims-receipt-search-container">
            <div className="search-boxes-container">
                {/* Warehouse Selection - Show only if user has "Receipt Retrieval Filter" permission */}
                {showWarehouseSelection && warehouseList.length > 0 && (
                    <div className="search-box">
                        <div className="box-header">Select Warehouse</div>
                        <div className="box-body">
                            <div className="d-flex flex-column">
                                <span className='d-flex inputTitle'>
                                    Warehouse
                                    &nbsp;<span className='color-red'>*</span>
                                </span>
                                <select
                                    className="warehouse-select-input"
                                    value={selectedWh?.relaysiteId || 'all'}
                                    onChange={(e) => {
                                        if (e.target.value === 'all') {
                                            setSelectedWarehouse({ relaysiteId: 'all', warehouseName: 'All' });
                                        } else {
                                            const warehouse = warehouseList.find(wh => wh.relaysiteId === e.target.value);
                                            setSelectedWarehouse(warehouse);
                                        }
                                    }}
                                >
                                    <option value="all">All</option>
                                    {warehouseList.map((warehouse) => (
                                        <option key={warehouse.relaysiteId} value={warehouse.relaysiteId}>
                                            {warehouse.warehouseName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                )}

                {
                    !isFSPay &&
                    <div className="search-box">
                        <div className="box-header">Find Receipt By Control Number</div>
                        <div className="box-body">
                            <InputWithTtile
                                title='Control Number'
                                value={controlNumber}
                                onEmailChange={(val) => {
                                    setPoNumber('')
                                    setControlNumber(val)
                                }}
                                required={true}
                            />
                        </div>
                    </div>
                }

                {!isFSPay && <div className="separator">OR</div>}
                <div className="search-box">
                    <div className="box-header">Find Receipt by PO</div>
                    <div className="box-body">
                        <InputWithTtile
                            title='PO'
                            value={poNumber}
                            onEmailChange={(val) => {
                                setControlNumber('')
                                setPoNumber(val)
                            }}
                            required={true}
                        />
                    </div>
                </div>
            </div>
            <div className="button-container">
                <CustomButtonSS
                    title='Reset'
                    onClick={handleReset}
                    className={`addButton`}
                    disabled={poNumber || controlNumber || selectedWh ? false : true}
                />
                <CustomButtonSS
                    title='Lookup'
                    onClick={handleSearch}
                    className={`addButton`}
                    disabled={isFSPay ? !poNumber : !(poNumber || controlNumber)}
                />
            </div>
        </div>
    );
};

export default ImsReceiptSearch;
